import {
  Alert,
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Empty,
  Form,
  Icon,
  Input,
  message,
  Pagination,
  Popconfirm,
  Row,
  Select,
  Table,
} from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component, FormEvent } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';

import { Panel } from '../../components/Panel';
import { FormatDate } from '../../components/table/Date';
import { DateRange, PageInfo } from '../../types/base';
import { Sku } from '../enrollment/Enrollment';

const FormItem = Form.Item;
export const skuListQuery = gql`
  query getSkuListQuery(
    $ids: [ID]
    $name: String
    $startRange: DateRange
    $take: Int
    $skip: Int
    $after: ID
    $before: ID
  ) {
    skusConnection(
      ids: $ids
      name: $name
      startRange: $startRange
      take: $take
      skip: $skip
      after: $after
      before: $before
    ) {
      nodes {
        id
        name
        start
        end
        availableFrom
        availableUntil
        price
        soldStock
        totalStock
        completeCourseAt
        totalStock
        courseId
        createdAt
        course {
          id
          name
        }
        noneGroupEnrollments {
          id
        }
        enrollmentGroups {
          id
          enrollments {
            id
          }
        }
      }
      pageInfo {
        totalCount
        startCursor
        endCursor
      }
    }
  }
`;

const allocateEnrollmentGroupMutation = gql`
  mutation allocateEnrollmentGroup($skuId: ID!) {
    allocateEnrollmentGroup(skuId: $skuId) {
      id
    }
  }
`;

export interface SkusData {
  skusConnection: { nodes: Sku[]; pageInfo: PageInfo };
}

interface State {
  startRange?: DateRange | undefined;

  skuList?: { id: number; name: string }[];
  skuName?: string;
  currentPage: number;
  take: number;
  skip?: number;
  before?: number;
  after?: number;
}

interface Props {
  form: WrappedFormUtils;
}
type SkuProps = RouteComponentProps<{ from: string }> & Props;
const SKUS_COUNT_PER_PAGE = 50;
export class SkuForm extends Component<SkuProps, State> {
  constructor(props: SkuProps) {
    super(props);
    this.state = {
      currentPage: 1,
      skip: 0,
      take: SKUS_COUNT_PER_PAGE,
    };
    this.onResetClick = this.onResetClick.bind(this);
  }

  async componentDidMount() {
    this.props.form.validateFields();
  }

  onSkuNameInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      skuName: e.target.value,
    });
  };

  handleSearch = (value: string, allSku: { id: number; name: string }[]) => {
    const arr: { id: number; name: string }[] = [];
    const reg = new RegExp(value, 'gi');
    for (const sku of allSku) {
      const n = sku.name.search(reg);
      if (n !== -1) {
        arr.push(sku);
      }
    }
    this.setState({ skuList: arr });
  };

  onResetClick() {
    this.props.form.resetFields();
  }

  search = (e: FormEvent) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      const startRange =
        values.date && values.date.length > 1
          ? {
              from: moment(values.date[0]).startOf('day').toDate(),
              to: moment(values.date[1]).endOf('day').toDate(),
            }
          : undefined;

      if (err) {
        message.error(err);
        return;
      }
      this.setState({
        startRange,
        skuName: values.skuName,
        take: SKUS_COUNT_PER_PAGE,
        skip: 0,
        currentPage: 1,
      });
    });
  };
  render() {
    const { from } = this.props.match.params;
    const { getFieldDecorator } = this.props.form;
    const { startRange, skuList, take, skuName, skip, before, after, currentPage } = this.state;
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>社群管理</Breadcrumb.Item>
        </Breadcrumb>
        <Query<SkusData> query={skuListQuery} variables={{ startRange, take, skip, before, after, name: skuName }}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const skusConnection = (data && data.skusConnection) || [];
            const { nodes: skus = [] } = skusConnection;
            const allSku = skus.map(sku => {
              const skuList = { id: sku.id, name: sku.name };
              return skuList;
            });
            const noneGroupEnrollmentsCount = skus.reduce((acc, cur) => {
              return acc + cur.noneGroupEnrollments.length;
            }, 0);
            return (
              <>
                <Panel style={{ padding: 24 }}>
                  <Form layout="inline" onSubmit={this.search}>
                    <Row gutter={24}>
                      <Col xs={24} md={24} lg={24} xl={8} xxl={8}>
                        <FormItem label={`skuName:`}>
                          {getFieldDecorator('skuName')(<Input style={{ width: '300px' }} allowClear />)}
                        </FormItem>
                      </Col>

                      <Col xs={24} md={24} lg={24} xl={8} xxl={8}>
                        <FormItem label={`时间:`}>
                          {getFieldDecorator('date')(
                            <DatePicker.RangePicker
                              ranges={{
                                今天: [moment(), moment()],
                                本周: [moment().startOf('week'), moment().endOf('week')],
                                上周: [
                                  moment().startOf('week').subtract(1, 'week'),
                                  moment().endOf('week').subtract(1, 'week'),
                                ],
                              }}
                            />,
                          )}
                        </FormItem>
                      </Col>
                      <Col xs={24} md={24} lg={24} xl={8} xxl={8}>
                        <Button style={{ marginRight: 8 }} type="primary" htmlType="submit" icon="search">
                          搜索
                        </Button>
                        <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                          重置
                        </Button>
                        <Button type="primary" icon="download">
                          导出
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Panel>
                {noneGroupEnrollmentsCount > 0 && (
                  <Alert
                    message={`有 ${noneGroupEnrollmentsCount} 名用户未分配班主任`}
                    type="warning"
                    showIcon
                    style={{ marginTop: 16 }}
                  />
                )}
                <Panel style={{ marginTop: 16 }}>
                  <Table
                    dataSource={skus}
                    pagination={false}
                    loading={loading}
                    rowKey={record => `${record.id}`}
                    footer={() => (
                      <Pagination
                        style={{ float: 'right', marginBottom: 16 }}
                        total={
                          skusConnection &&
                          skusConnection.pageInfo &&
                          skusConnection.pageInfo.totalCount &&
                          skusConnection.pageInfo.totalCount
                        }
                        pageSize={take}
                        current={currentPage}
                        onChange={nextPage => {
                          const pageSkip = (Math.abs(nextPage - currentPage) - 1) * SKUS_COUNT_PER_PAGE;

                          if (nextPage > currentPage) {
                            this.setState({
                              startRange,
                              skuName,
                              skip: pageSkip,
                              take: SKUS_COUNT_PER_PAGE,
                              after: skusConnection.pageInfo.endCursor,
                              before: undefined,
                            });
                          }
                          if (nextPage < currentPage) {
                            this.setState({
                              startRange,
                              skuName,
                              skip: pageSkip,
                              take: SKUS_COUNT_PER_PAGE,
                              after: undefined,
                              before: skusConnection.pageInfo.startCursor,
                            });
                          }
                          this.setState({
                            currentPage: nextPage,
                          });
                        }}
                      />
                    )}
                  >
                    <Table.Column title="课程SKU" dataIndex="name" key="skuName" />
                    <Table.Column
                      title="社群数量"
                      dataIndex="enrollmentGroups"
                      key="GroupsLength"
                      render={enrollmentGroups => <span>{(enrollmentGroups && enrollmentGroups.length) || 0}</span>}
                    />
                    <Table.Column<Sku>
                      title="未分配人数"
                      dataIndex="noneGroupEnrollments"
                      key="NoneGroupLength"
                      render={noneGroupEnrollments => (
                        <span>{(noneGroupEnrollments && noneGroupEnrollments.length) || 0}</span>
                      )}
                    />
                    <Table.Column<Sku>
                      title="开课时间"
                      dataIndex="start"
                      key="skuStart"
                      render={start => <FormatDate mode="date" date={start} />}
                      defaultSortOrder="descend"
                      sorter={(a, b) => {
                        return moment(a.start).valueOf() - moment(b.start).valueOf();
                      }}
                    />
                    <Table.Column<Sku>
                      title="操作"
                      key="action"
                      dataIndex="id"
                      render={(id: number, record) => (
                        <>
                          <Link to={from === 'group' ? `/group/sku/${id}/grouplist` : `/teacher/list/${id}`}>详情</Link>
                          <Link to={`/group/allocateTeacher/${id}`} style={{ marginLeft: 5 }}>
                            配置班主任
                          </Link>
                          {record.noneGroupEnrollments.length > 0 && (
                            <Mutation mutation={allocateEnrollmentGroupMutation} variables={{ skuId: record.id }}>
                              {(allocateEnrollmentGroup, { loading, error }) => {
                                return (
                                  <>
                                    <Popconfirm
                                      title={
                                        <Card
                                          title="确定给未分配用户分配班主任吗？"
                                          bordered={false}
                                          style={{ width: 300 }}
                                        >
                                          <p>SKU名称: {record.name} </p>
                                          <p>待分配人数: {record.noneGroupEnrollments.length} </p>
                                          <p style={{ color: 'red' }}>请确认已正确配置班主任排班</p>
                                        </Card>
                                      }
                                      icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}
                                      onConfirm={() => allocateEnrollmentGroup()}
                                      okText="确定"
                                      cancelText="取消"
                                    >
                                      <Button type="link" loading={loading} size="small" style={{ marginLeft: 5 }}>
                                        分配班主任
                                      </Button>
                                    </Popconfirm>
                                    {error && <p style={{ color: 'red' }}>{error.message}</p>}
                                  </>
                                );
                              }}
                            </Mutation>
                          )}
                        </>
                      )}
                    />
                  </Table>
                </Panel>
              </>
            );
          }}
        </Query>
      </>
    );
  }
}

export const SkuList = Form.create({ name: 'SkuList' })(SkuForm);



// WEBPACK FOOTER //
// ./src/screens/group/skuList.tsx